import { Injectable } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import { EntityCredential } from 'src/app/shared/models/credential/entityCredential';
import { EntityCredentialApplication } from 'src/app/shared/models/credential/entityCredentialApplication';
import { PortalBaseService } from 'src/portal/portal-base.service';

@Injectable({
  providedIn: 'root'
})
export class PortalTeamManagerService extends PortalBaseService {
  public getMyTeamCredentials(
    teamId: string
  ): Promise<{ credentials: EntityCredential[]; applications: EntityCredentialApplication[] }> {
    return lastValueFrom(
      this.get<{ credentials: EntityCredential[]; applications: EntityCredentialApplication[] }>(
        `portal/teams/${teamId}/credentials`
      ).pipe(
        map(
          (res: {
            credentials: EntityCredential[];
            applications: EntityCredentialApplication[];
          }) => {
            if (res) {
              return {
                credentials: EntityCredential.parseMany(res.credentials),
                applications: EntityCredentialApplication.parseMany(res.applications)
              };
            }
            return { credentials: [], applications: [] };
          }
        )
      )
    );
  }
}
